import React, { ReactElement } from 'react';

import LanguageIcon from '../../../assets/icons/LanguageIcon';
import useLanguage from '../../../hooks/useLanguage';

import { mergeClassNames } from '../../../utils';

import {
  LANGUAGE_DISPLAY_ENGLISH,
  LANGUAGE_DISPLAY_SPANISH,
  LANGUAGE_DISPLAY_PORTUGUESE,
  LANGUAGE_ENGLISH,
  LANGUAGE_SPANISH,
  LANGUAGE_PORTUGUESE,
} from '../../../constants';

import styles from './LanguageToggle.css';

const LanguageToggle = (): ReactElement => {
  const { currentLanguage, assignLanguage } = useLanguage();

  return (
    <div className={styles.ovalRow}>
      <div
        className={mergeClassNames(
          styles.languageButton,
          currentLanguage === LANGUAGE_ENGLISH ? styles.selected : '',
        )}
        onClick={() => {
          assignLanguage(LANGUAGE_ENGLISH);
        }}
      >
        <LanguageIcon isSelected={currentLanguage === LANGUAGE_ENGLISH} />
        <span className={styles.languageTitle}>{LANGUAGE_DISPLAY_ENGLISH}</span>
      </div>

      <div
        className={mergeClassNames(
          styles.languageButton,
          currentLanguage === LANGUAGE_SPANISH ? styles.selected : '',
        )}
        onClick={() => {
          assignLanguage(LANGUAGE_SPANISH);
        }}
      >
        <LanguageIcon isSelected={currentLanguage === LANGUAGE_SPANISH} />
        <span className={styles.languageTitle}>{LANGUAGE_DISPLAY_SPANISH}</span>
      </div>

      <div
        className={mergeClassNames(
          styles.languageButton,
          currentLanguage === LANGUAGE_PORTUGUESE ? styles.selected : '',
        )}
        onClick={() => {
          assignLanguage(LANGUAGE_PORTUGUESE);
        }}
      >
        <LanguageIcon isSelected={currentLanguage === LANGUAGE_PORTUGUESE} />
        <span className={styles.languageTitle}>{LANGUAGE_DISPLAY_PORTUGUESE}</span>
      </div>
    </div>
  );
};

export default LanguageToggle;